import { z } from "zod";

export const projectSchema = z.object({
  Title: z.string(),
  Description: z.string().optional(),
  Url: z.literal("").or(z.string().url()).optional(),
  "Started On": z.string().optional(),
  "Finished On": z.string().optional(),
});
